// ======================================================
// REHBER360 — AKILLI PLAN ROBOTU
// ÇALIŞMA STRATEJİLERİ
// ======================================================
//
// Bu dosya öğrencinin "nasıl bir çalışma planı"
// istediğini tanımlar.
//
// Burada:
// - Ders seçilmez
// - Konu seçilmez
// - Günlere görev yerleştirilmez
//
// Sadece planın çalışma karakteri belirlenir.
//
// Örn:
// Başlangıç → daha düşük yük, daha fazla temel çalışma
// Telafi → eksik konu ve tekrar ağırlıklı
// Son Düzlük → deneme, analiz ve mikro tekrar ağırlıklı
//
// ======================================================

export const SMART_PLAN_STRATEGY_IDS = {
  BASLANGIC: "baslangic",
  DENGELI: "dengeli",
  TELAFI: "telafi",
  GENEL_TEKRAR: "genel_tekrar",
  SON_DUZLUK: "son_duzluk",
  DENEME_ODAKLI: "deneme_odakli"
};


// ======================================================
// STRATEJİ KATALOĞU
// ======================================================

export const SMART_PLAN_STRATEGIES = {

  // ------------------------------------------------------
  // 1. BAŞLANGIÇ
  // ------------------------------------------------------

  [SMART_PLAN_STRATEGY_IDS.BASLANGIC]: {
    id: SMART_PLAN_STRATEGY_IDS.BASLANGIC,

    label: "Başlangıç Programı",

    shortLabel: "Başlangıç",

    description:
      "Çalışma düzenini yeni oluşturan veya temelden ilerlemek isteyen öğrenciler için daha kontrollü bir başlangıç programı.",

    recommendedFor: [
      "Düzenli çalışma alışkanlığı olmayan öğrenciler",
      "Temel eksikleri bulunan öğrenciler",
      "Yoğun programa doğrudan başlamak istemeyen öğrenciler"
    ],

    workloadMultiplier: 0.8,

    preferredDifficulty: "Kolay",

       maxHeavyTasksPerDay: 1,

    // Başlangıç öğrencisinde yüksek kapasite,
    // çok sayıda yeni konu açılması anlamına gelmez.
    //
    // Bu değerler birer pedagojik pacing kuralıdır.
    // İlk iterasyonda özellikle TYT Matematik
    // haftada en fazla 1 yeni konu açar.
    newTopicPacing: {
      defaultPerWeek: 1,

      subjectOverrides: {
        'TYT - Matematik': 1,
        'TYT - Geometri': 1,
        'TYT - Türkçe': 2
      },

      // Yeni konu açıldıktan sonra plan içerisinde
      // en az bu kadar çalışma günü daha kalmalıdır.
      //
      // Amaç:
      // Planın son gününde yeni konu açıp öğrenciyi
      // hiç uygulama fırsatı bırakmadan bırakmamak.
      minimumFollowUpWorkingDays: 1
    },

    ratios: {
      newTopic: 0.45,
      practice: 0.25,
      review: 0.20,
      assessment: 0.10
    },

    repetition: {
      enabled: true,
      firstReviewAfterDays: 3,
      secondReviewAfterDays: 7
    },

    buffer: {
      enabled: true,
      weeklySlots: 1
    },

    assessment: {
      fullMockExamFrequencyWeeks: 0,
      branchExamFrequencyWeeks: 2,
      analysisRequired: true
    },

    allowNewTopics: true,

    prioritizeWeakTopics: false
  },


  // ------------------------------------------------------
  // 2. DENGELİ İLERLEME
  // ------------------------------------------------------

  [SMART_PLAN_STRATEGY_IDS.DENGELI]: {
    id: SMART_PLAN_STRATEGY_IDS.DENGELI,

    label: "Dengeli İlerleme",

    shortLabel: "Dengeli",

    description:
      "Yeni konu, soru çözümü, tekrar ve deneme çalışmalarını dengeli biçimde bir arada götüren standart çalışma modeli.",

    recommendedFor: [
      "Düzenli çalışan öğrenciler",
      "Müfredatta sistemli ilerlemek isteyen öğrenciler",
      "Uzun dönemli çalışma programları"
    ],

   workloadMultiplier: 0.95,

    preferredDifficulty: "Orta",

maxHeavyTasksPerDay: 2,

newTopicPacing: {
  minimumFollowUpWorkingDays: 1
},

ratios: {
  newTopic: 0.50,
  practice: 0.25,
  review: 0.15,
  assessment: 0.10
},

    repetition: {
      enabled: true,
      firstReviewAfterDays: 4,
      secondReviewAfterDays: 10
    },

    buffer: {
      enabled: true,
      weeklySlots: 1
    },

    assessment: {
      fullMockExamFrequencyWeeks: 2,
      branchExamFrequencyWeeks: 1,
      analysisRequired: true
    },

    allowNewTopics: true,

    prioritizeWeakTopics: false
  },


  // ------------------------------------------------------
  // 3. TELAFİ
  // ------------------------------------------------------

  [SMART_PLAN_STRATEGY_IDS.TELAFI]: {
    id: SMART_PLAN_STRATEGY_IDS.TELAFI,

    label: "Telafi Programı",

    shortLabel: "Telafi",

    description:
      "Eksik kalan, unutulan veya tamamlanamayan konuları yeniden programa alarak açığı kapatmaya odaklanan çalışma modeli.",

    recommendedFor: [
      "Programın gerisinde kalan öğrenciler",
      "Konu eksikleri biriken öğrenciler",
      "Belirli dersleri yeniden toparlamak isteyen öğrenciler"
    ],

    workloadMultiplier: 0.95,

    preferredDifficulty: "Orta",

       maxHeavyTasksPerDay: 2,

    // Telafi programında yeni konu ana amaç değildir.
    //
    // NEW_TOPIC üretildiyse planın sonuna kadar
    // orantılı biçimde sürüklenmemeli; öğrencinin
    // PRACTICE / REVIEW çalışmaları için gerçek
    // takip alanı bırakılmalıdır.
    //
    // Bu pacing NEW_TOPIC sayısını artırmaz.
    // Yalnız üretilmiş yeni konuların takvimdeki
    // hedef konumunu kontrollü biçimde öne çeker.
    newTopicPacing: {
      defaultPerWeek: 1,

      minimumFollowUpWorkingDays: 1
    },

    ratios: {
      newTopic: 0.15,
      practice: 0.35,
      review: 0.40,
      assessment: 0.10
    },

    repetition: {
      enabled: true,
      firstReviewAfterDays: 2,
      secondReviewAfterDays: 6
    },

    buffer: {
      enabled: true,
      weeklySlots: 2
    },

    assessment: {
      fullMockExamFrequencyWeeks: 2,
      branchExamFrequencyWeeks: 1,
      analysisRequired: true
    },

    allowNewTopics: true,

    prioritizeWeakTopics: true
  },


  // ------------------------------------------------------
  // 4. GENEL TEKRAR
  // ------------------------------------------------------

  [SMART_PLAN_STRATEGY_IDS.GENEL_TEKRAR]: {
    id: SMART_PLAN_STRATEGY_IDS.GENEL_TEKRAR,

    label: "Genel Tekrar",

    shortLabel: "Genel Tekrar",

    description:
      "Daha önce çalışılmış konuları yeniden hatırlama, karma soru çözümü ve eksik belirleme üzerine kurulu tekrar programı.",

    recommendedFor: [
      "Müfredatın önemli bölümünü tamamlayan öğrenciler",
      "Sınav öncesi bilgilerini toparlamak isteyen öğrenciler",
      "Karma tekrar yapmak isteyen öğrenciler"
    ],

    workloadMultiplier: 1,

    preferredDifficulty: "Orta",

        maxHeavyTasksPerDay: 2,

    // Genel Tekrar'da yeni konu ana çalışma alanı değildir.
    //
    // NEW_TOPIC üretildiyse planın sonuna sürüklenmemeli;
    // PRACTICE / REVIEW ile gerçek takip alanı kalmalıdır.
    //
    // Bu pacing NEW_TOPIC bütçesini artırmaz.
    // Yalnız üretilmiş yeni konuların takvimdeki
    // hedef konumunu kontrollü biçimde öne çeker.
    newTopicPacing: {
      defaultPerWeek: 1,
      minimumFollowUpWorkingDays: 1
    },

    ratios: {
      newTopic: 0.05,
      practice: 0.40,
      review: 0.35,
      assessment: 0.20
    },

    repetition: {
      enabled: true,
      firstReviewAfterDays: 3,
      secondReviewAfterDays: 7
    },

    buffer: {
      enabled: true,
      weeklySlots: 1
    },

    assessment: {
      fullMockExamFrequencyWeeks: 1,
      branchExamFrequencyWeeks: 1,
      analysisRequired: true
    },

    allowNewTopics: true,

    prioritizeWeakTopics: true
  },


  // ------------------------------------------------------
  // 5. SON DÜZLÜK
  // ------------------------------------------------------

  [SMART_PLAN_STRATEGY_IDS.SON_DUZLUK]: {
    id: SMART_PLAN_STRATEGY_IDS.SON_DUZLUK,

    label: "Son Düzlük",

    shortLabel: "Son Düzlük",

    description:
      "Sınava yaklaşan dönemde deneme, yanlış analizi, hız çalışması ve kritik konu tekrarlarına ağırlık veren yoğun sınav hazırlığı.",

    recommendedFor: [
      "Sınava az zamanı kalan öğrenciler",
      "Konu öğrenme sürecini büyük ölçüde tamamlayan öğrenciler",
      "Deneme performansını artırmak isteyen öğrenciler"
    ],

    workloadMultiplier: 1.05,

    preferredDifficulty: "Otomatik",

    maxHeavyTasksPerDay: 2,

    ratios: {
      newTopic: 0.05,
      practice: 0.25,
      review: 0.25,
      assessment: 0.45
    },

    repetition: {
      enabled: true,
      firstReviewAfterDays: 2,
      secondReviewAfterDays: 5
    },

    buffer: {
      enabled: true,
      weeklySlots: 1
    },

    assessment: {
      fullMockExamFrequencyWeeks: 1,
      branchExamFrequencyWeeks: 1,
      analysisRequired: true
    },

    allowNewTopics: false,

    prioritizeWeakTopics: true
  },


  // ------------------------------------------------------
  // 6. DENEME ODAKLI
  // ------------------------------------------------------

  [SMART_PLAN_STRATEGY_IDS.DENEME_ODAKLI]: {
    id: SMART_PLAN_STRATEGY_IDS.DENEME_ODAKLI,

    label: "Deneme Odaklı",

    shortLabel: "Deneme Odaklı",

    description:
      "Deneme uygulamalarını merkeze alan; diğer çalışmaları deneme sonuçlarında görülen ihtiyaçları destekleyecek şekilde düzenleyen program.",

    recommendedFor: [
      "Sınav pratiğini artırmak isteyen öğrenciler",
      "Konu eksiğinden çok uygulama eksiği bulunan öğrenciler",
      "Süre ve sınav stratejisi geliştirmek isteyen öğrenciler"
    ],

    workloadMultiplier: 1,

    preferredDifficulty: "Otomatik",

    maxHeavyTasksPerDay: 2,

    ratios: {
      newTopic: 0,
      practice: 0.25,
      review: 0.20,
      assessment: 0.55
    },

    repetition: {
      enabled: true,
      firstReviewAfterDays: 2,
      secondReviewAfterDays: 5
    },

    buffer: {
      enabled: true,
      weeklySlots: 1
    },

    assessment: {
      fullMockExamFrequencyWeeks: 1,
      branchExamFrequencyWeeks: 1,
      analysisRequired: true
    },

    allowNewTopics: false,

    prioritizeWeakTopics: true
  }
};


// ======================================================
// STRATEJİ LİSTESİ
// UI TARAFINDA KULLANILACAK
// ======================================================

export const SMART_PLAN_STRATEGY_OPTIONS =
  Object.values(SMART_PLAN_STRATEGIES).map(strategy => ({
    value: strategy.id,
    label: strategy.label,
    shortLabel: strategy.shortLabel,
    description: strategy.description
  }));


// ======================================================
// STRATEJİ GETİR
// ======================================================

export const getSmartPlanStrategy = strategyId => {
  return (
    SMART_PLAN_STRATEGIES[strategyId] ||
    SMART_PLAN_STRATEGIES[SMART_PLAN_STRATEGY_IDS.DENGELI]
  );
};


// ======================================================
// STRATEJİ DAĞILIM KONTROLÜ
// ======================================================

export const validateSmartPlanStrategy = strategy => {
  if (!strategy) {
    return {
      valid: false,
      reason: "STRATEGY_NOT_FOUND"
    };
  }

  const {
    newTopic = 0,
    practice = 0,
    review = 0,
    assessment = 0
  } = strategy.ratios || {};

  const total =
    newTopic +
    practice +
    review +
    assessment;

  const valid =
    Math.abs(total - 1) < 0.0001;

  return {
    valid,
    total,
    reason: valid
      ? null
      : "INVALID_STRATEGY_RATIO"
  };
};


// ======================================================
// TÜM STRATEJİLERİ KONTROL ET
// ======================================================

export const validateAllSmartPlanStrategies = () => {
  return Object.values(SMART_PLAN_STRATEGIES).map(strategy => ({
    id: strategy.id,
    label: strategy.label,
    ...validateSmartPlanStrategy(strategy)
  }));
};